import { Controller } from "@hotwired/stimulus"

// Opens a native <dialog> reviewer picker for one edition and keeps its submit
// button in step with the checkboxes: the button is disabled whenever no
// reviewer is checked, so a preview can never be sent to nobody. Esc-to-close
// and focus trapping come from <dialog> itself.
//
// Usage:
//   data-controller="reviewer-picker"
//   Trigger button:  data-action="reviewer-picker#open"
//   Dialog element:  data-reviewer-picker-target="dialog"
//                    data-action="click->reviewer-picker#backdropClose"
//   Each checkbox:   data-reviewer-picker-target="checkbox"
//                    data-action="reviewer-picker#refresh"
//   Submit button:   data-reviewer-picker-target="submit"
export default class extends Controller {
  static targets = ["dialog", "checkbox", "submit"]

  open() {
    this.dialogTarget.showModal()
    this.#syncSubmit()
  }

  close() {
    this.dialogTarget.close()
  }

  // A native <dialog> doesn't close on backdrop click; do it manually when the
  // click lands on the dialog element itself rather than on its content.
  backdropClose(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  refresh() {
    this.#syncSubmit()
  }

  #syncSubmit() {
    this.submitTarget.disabled = !this.checkboxTargets.some((box) => box.checked)
  }
}
